import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { QueryOptions } from "@utils/reactQuery";

import client from ".";
import { RequestParams } from "./types";

type MetaType = { totalEntries: number };
export type HookOptions = QueryOptions & {
  id?: number | string | null;
  params?: RequestParams;
};

type ResourceReturnType<T> = UseQueryResult<T> & { meta: MetaType };

function useApiResource<T>(
  resource: string,
  opts: { id: string }
): ResourceReturnType<T>;
function useApiResource<T>(
  resource: string,
  opts?: HookOptions
): ResourceReturnType<T[]>;
function useApiResource<T>(resource: string, opts?: HookOptions) {
  const options: HookOptions = opts ?? {};
  const { id, params, ...queryOptions } = options;

  const url = options.id ? `${resource}/${options.id}` : resource;
  const queryKey = id ? [url, "detail", id] : [url, "list", params];
  type DataType = typeof id extends undefined ? T[] : T;
  const query = useQuery({
    queryKey,
    queryFn: () =>
      client.get<DataType>(url, { params }).then((res) => res.data),
    ...queryOptions,
  });

  return query;
}

export default useApiResource;
